<bic-popup (close)="close()" [hasBackdrop]="true" [title]="'Bild bearbeiten'" customClass="w-[421px] h-fit">
  <div bicPopupContent class="flex flex-col items-center p-2 gap-8">
    <div class="flex flex-row justify-center items-center">
        <div class="rounded-full border border-gray-200 w-[220px] h-[220px] flex items-center justify-center bg-white">
          <img #image id="image" height="400" [src]="sanitizedUrl">
        </div>
    </div>
  </div>

  <div bicPopupButtonGroup class="flex flex-row justify-between w-full gap-4">
    <bic-button buttonType="white" (onClick)="close()">Abbrechen</bic-button>
    <bic-button (onClick)="reset()">Zurücksetzen</bic-button>
    <bic-button (onClick)="crop()">Auswählen</bic-button>
  </div>
</bic-popup>

